/**
 * Carries the current query string (e.g. ?site=) onto a route. Params already
 * on the route, such as a class link's ?class=, take precedence.
 */
export const appendSearchToRoute = (route, search) => {
  if (!search) return route

  const [path, routeQuery = ''] = route.split('?')
  const params = new URLSearchParams(search)
  new URLSearchParams(routeQuery).forEach((value, key) => {
    params.set(key, value)
  })
  const query = params.toString()

  return query ? `${path}?${query}` : path
}

export const withCurrentSearch = ({ item, search }) => {
  if (Array.isArray(item?.items)) {
    return {
      ...item,
      items: item.items.map(child =>
        withCurrentSearch({ item: child, search }),
      ),
    }
  }

  return item?.route
    ? { ...item, route: appendSearchToRoute(item.route, search) }
    : item
}
